var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSieraLogoPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M9.3603 0.928749C8.63207 1.38377 8.02782 2.02509 7.45763 2.94742C6.73248 4.12086 5.82275 5.18899 4.75414 6.12277C4.14738 6.65348 3.49203 7.13531 2.8082 7.55346C1.0781 8.5945 0.0282021 10.4679 0 12.5771C0.0290398 14.629 1.20348 16.5591 3.05923 17.6116C3.85391 18.101 4.53299 18.6228 5.13417 19.2063C5.86073 19.9194 6.77911 20.88 7.43669 21.9841C8.45252 23.8162 10.4373 25 12.4924 25C12.7007 25 12.9112 24.9877 13.1145 24.9637C14.9904 24.7872 16.6995 23.6243 17.6821 21.8604C18.4012 20.7079 19.3067 19.6697 20.3789 18.7714C20.9033 18.3001 21.5106 17.8599 22.2914 17.3856C23.1623 16.8563 23.8453 16.1295 24.32 15.2295C25.6519 12.8455 24.9669 9.5875 22.7929 7.96742L22.3696 7.67301C21.008 6.73058 19.7225 5.84009 18.7245 4.55576C18.2386 3.98818 17.85 3.45439 17.5369 2.92396C16.8958 1.83823 16.0877 1.07512 15.0714 0.593561C14.2862 0.196085 13.4099 0 12.5309 0C11.4199 -0.000278473 10.3041 0.313122 9.3603 0.928749ZM9.44518 20.0859C6.25165 18.7878 4.27666 15.8815 4.29118 12.4972C4.27415 9.17689 6.19692 6.28617 9.30864 4.9538C10.3767 4.49599 11.4863 4.26387 12.6077 4.26387C14.6698 4.26387 16.6403 5.06832 18.1602 6.53226C19.7565 7.97468 20.6931 10.1012 20.7288 12.3659C20.7648 14.6257 19.8964 16.7778 18.3461 18.2705L18.3414 18.275C16.7934 19.8803 14.7595 20.723 12.6362 20.723C11.5785 20.7233 10.4987 20.5141 9.44518 20.0859Z",
    fill: "url(#paint0_linear_7174_1235)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7174_1235",
    x1: -0.625001,
    y1: -3.52387e-7,
    x2: 24.3837,
    y2: 25.6165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549517,
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009C8D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSieraLogoPrimary);
export default __webpack_public_path__ + "static/media/siera-logo-primary.cb03bf186619a0738462189067ae0ab7.svg";
export { ForwardRef as ReactComponent };